export default __webpack_public_path__ + "static/media/REJEFEMAC MOUVEMENT_n.a4394a25.jpg";